<template>
  <div
    ref="region"
    data-shell="bar-stack"
    class="pointer-events-none absolute inset-x-0 bottom-0 z-40 flex justify-center lg:bottom-5">
    <div ref="bars" class="pointer-events-auto flex w-full flex-col gap-2 lg:w-[36rem] lg:max-w-[calc(100%-16px)]">
      <div :data-shell="BOTTOM_STACK_TARGETS.bars" class="contents" />
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BOTTOM_STACK_TARGETS, useBottomStack } from '@dashboard/composables/useBottomStack'
import { useElementBounding, useElementSize } from '@vueuse/core'
import { onBeforeUnmount, useTemplateRef, watchEffect } from 'vue'

// The region spans the page card's full width, so it resizes (and is
// re-measured) whenever the sidebar or Righty dock moves the card. The bars
// column is centred in it, so its left edge follows from the region's.
const region = useTemplateRef<HTMLElement>('region')
const bars = useTemplateRef<HTMLElement>('bars')
const { left, width, top, height } = useElementBounding(region, { windowScroll: false })
const { width: barsWidth } = useElementSize(bars, undefined, { box: 'border-box' })
const { setBarStackBox } = useBottomStack()
watchEffect(() =>
  setBarStackBox({
    left: left.value,
    width: width.value,
    top: top.value,
    height: height.value,
    barsLeft: left.value + (width.value - barsWidth.value) / 2,
    barsWidth: barsWidth.value
  })
)
onBeforeUnmount(() => setBarStackBox(null))
</script>
